/**
 * Sysnet API
 *  ## Authorization We use bearer auth throughout the API. Generally, API requests should have the follow header:   {       \"content-type\": \"application/json\",       \"Authorization\": \"Bearer TOKEN_GOES_HERE\"   }   Please refer to the Auth section immediately below for details on getting your token.
 *
 * OpenAPI spec version: 1.0.4
 * Contact: support@hlpos.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { HttpError } from '../model/httpError';
import { ReportTemplateColumnSettingBulkInsertInner } from '../model/reportTemplateColumnSettingBulkInsertInner';
import { ReportTemplateColumnSettingBulkInsertView } from '../model/reportTemplateColumnSettingBulkInsertView';
import { ReportTemplateColumnSettingInsert } from '../model/reportTemplateColumnSettingInsert';
import { ReportTemplateColumnSettingUpdate } from '../model/reportTemplateColumnSettingUpdate';
import { ReportTemplateColumnSettingView } from '../model/reportTemplateColumnSettingView';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class ReportTemplateColumnSettingsService {

    protected basePath = 'https://develop-sysnet-api.hlcloud.com.au';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * Creates multiple new ReportTemplateColumnSetting records&lt;br&gt;&lt;br&gt;Defines the column settings in the grid view for each template.&lt;br&gt;&lt;br&gt;You will need to have the following data accesses assigned to your user to use this route: sc_insert_reporttemplatecolumnsettings
     * @param body 
     * @param ridChain The rid_chain is used to track the current users session. It should be a unique value that identifies a users particular session in a particular device. When events are received through H&amp;L websocket events, the current user&#x27;s session can be identified with this value. As such this value can help you determine which device a user was on when they made a request on this API.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public reportTemplateColumnSettingsBulkInsertPost(body?: Array<ReportTemplateColumnSettingBulkInsertInner>, ridChain?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<ReportTemplateColumnSettingBulkInsertView>>;
    public reportTemplateColumnSettingsBulkInsertPost(body?: Array<ReportTemplateColumnSettingBulkInsertInner>, ridChain?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ReportTemplateColumnSettingBulkInsertView>>>;
    public reportTemplateColumnSettingsBulkInsertPost(body?: Array<ReportTemplateColumnSettingBulkInsertInner>, ridChain?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ReportTemplateColumnSettingBulkInsertView>>>;
    public reportTemplateColumnSettingsBulkInsertPost(body?: Array<ReportTemplateColumnSettingBulkInsertInner>, ridChain?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let headers = this.defaultHeaders;
        if (ridChain !== undefined && ridChain !== null) {
            headers = headers.set('rid_chain', String(ridChain));
        }

        // authentication (BearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<Array<ReportTemplateColumnSettingBulkInsertView>>('post',`${this.basePath}/ReportTemplateColumnSettings/bulkInsert`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Search for ReportTemplateColumnSetting objects&lt;br&gt;&lt;br&gt;Defines the column settings in the grid view for each template.&lt;br&gt;&lt;br&gt;You will need to have the following data accesses assigned to your user to use this route: sc_get_reporttemplatecolumnsettings
     * @param ridChain The rid_chain is used to track the current users session. It should be a unique value that identifies a users particular session in a particular device. When events are received through H&amp;L websocket events, the current user&#x27;s session can be identified with this value. As such this value can help you determine which device a user was on when they made a request on this API.
     * @param group This parameter is used to group results.                         The fieldName can be any of the following: reportTemplateId.                         The sort could either have - to sort by descending and + to sort by ascending. See groupQuery schema for more info.                         For grouping using a nested field use &lt;object&gt;.&lt;field&gt; to specify the nested levels eg +Stock.name
     * @param groupSummary This parameter is used to summarise grouped results by aggregating the groups.                 The fieldName can be any of the following: templateColumnSettingId, reportTemplateId, columnOrder, groupOrder, sortOrder.                         The type could be count,min,max,sum,avg. See groupSummaryQuery schema for more info.
     * @param totalSummary This parameter is used to summarise all grouped results by aggregating all the groups sub groups.                 The fieldName can be any of the following: templateColumnSettingId, reportTemplateId, columnOrder, groupOrder, sortOrder.                         The type could be count,min,max,sum,avg. See groupSummaryQuery schema for more info.
     * @param searchDistinct This parameter is used to get the distinct values for a field.                  Only the field specified will be returned in the results. This can be used with filtering functionality, sort and limit.                  However it cannot be used with group, groupSummary or totalSummary.
     * @param sort This parameter is used to change the sorting of results returned.                          The default sort is templateColumnSettingId ascending.                          Use any fieldNames comma separated in the sort.                          Use + for ascending - for descending                          eg +updateDateTime.                         - templateColumnSettingId would sort by updateDateTime ascending and then templateColumnSettingId descending.  For sorting using a nested field use &amp;lt;object&amp;gt;.&amp;lt;field&amp;gt; to specify the nested levels eg +Stock.name                         For sorting using a nested field use &lt;object&gt;.&lt;field&gt; to specify the nested levels eg +Stock.name
     * @param limit This limits the amount of results returned. This default limit Is set to 20. The maximum limit is 200.
     * @param offset This parameter is used to change the default offset from 0. Offset is the position in the dataset of a particular record. By specifying offset, you retrieve a subset of records starting with the offset value. Eg: If you have 100 records in your result set, and you want to retrieve records 50 to 80, you will need to use offset&#x3D;49 and limit &#x3D; 30.
     * @param search This does an &lt;b&gt;advanced&lt;/b&gt; search using a url encoded JSON object. &lt;br&gt;&lt;br&gt;  Most fields available in the return object can be searched using this methodology. &lt;br&gt;Example: search&#x3D;{ \&quot;status\&quot;: \&quot;active\&quot;} would search the status field for the value: &#x27;active&#x27;.&lt;br&gt;&lt;br&gt;  Searching is also possible using nested fields. Use the following syntax: &amp;lt;object&amp;gt;.&amp;lt;field&amp;gt; to specify the nested field.&lt;br&gt; Example: search&#x3D;{ \&quot;Stock.name\&quot;: \&quot;Best Beer\&quot; }&lt;br&gt;&lt;br&gt;  There are a couple of extra operators that can be used in the search. These are $or, $and, $not. &lt;br&gt; Example: search&#x3D;{ \&quot;$or\&quot;: [ { \&quot;status\&quot;: \&quot;bad\&quot; }, { \&quot;status\&quot;: \&quot;worse\&quot; } ] }. Searches for the statuses of &#x27;bad&#x27; or &#x27;worse&#x27;.&lt;br&gt; The $or, $and and $not operators can be nested.&lt;br&gt;&lt;br&gt;  If the name pair contains a fieldName it is possible for the value to be a sub-object containing any number of operators. The operators depend on the fieldType of the fieldName:&lt;br&gt;&lt;br&gt; &lt;b&gt;Date time Allowed Operators&lt;/b&gt;: $eq, $ne, $is, $gt, $gte, $lt, $lte, $in&lt;br&gt; Example: search&#x3D;{ \&quot;startTime\&quot;: { \&quot;$gt\&quot;: \&quot;2 November 2021\&quot; } }&lt;br&gt;&lt;br&gt; &lt;b&gt;Relative Date time Allowed Operators&lt;/b&gt;: $eq, $ne, $is, $gt, $gte, $lt, $lte, $in&lt;br&gt; Example: search&#x3D;{ \&quot;startTime\&quot;: { \&quot;$gt\&quot;: \&quot;2 November 2021\&quot; } }&lt;br&gt; &lt;em&gt;This &#x27;relativeDateTime&#x27; field is relative to the timezone a user resides in and is not an absolute point in time&lt;/em&gt;&lt;br&gt;&lt;br&gt; &lt;b&gt;Number Allowed Operators&lt;/b&gt;: $eq, $ne, $is, $not, $or, $gt, $gte, $lt, $lte, $between, $notBetween, $in, $notIn&lt;br&gt; Example: search&#x3D;{ \&quot;totalCount\&quot;: { \&quot;$gt\&quot;: 10 } } &lt;br&gt;&lt;br&gt; &lt;b&gt;String Allowed Operators&lt;/b&gt;: $eq, $ne, $is, $not, $or, $in, $like, $iLike, $notLike, $notILike, $notIn&lt;br&gt; Example: search&#x3D;{ \&quot;failReason\&quot;: { \&quot;$in\&quot;: [\&quot;Out of bounds\&quot;, \&quot;Out of time\&quot;] } }&lt;br&gt;&lt;br&gt;  These operators equate to Sequelize operators. See &lt;a href&#x3D;\&quot;https://sequelize.org/docs/v7/querying/operators\&quot;&gt;Operators | Sequelize&lt;/a&gt;
     * @param templateColumnSettingId Primary Key for the column setting entry.&lt;br&gt;&lt;b&gt;integer:&lt;/b&gt; This parameter searches the templateColumnSettingId field and returns all available results that match.   You can use &gt;10 to search for all templateColumnSettingIds greater than 10. You can use [1,2,3] to search for templateColumnSettingIds that match either 1, 2 or 3. You can use this parameter multiple times. eg templateColumnSettingId&#x3D;&gt;5&amp; templateColumnSettingId&#x3D;&lt;10 would search for all templateColumnSettingIds between 5 and 10.
     * @param reportTemplateId Foreign key to ReportTemplates table. Unique with column_name.&lt;br&gt;&lt;b&gt;integer:&lt;/b&gt; This parameter searches the reportTemplateId field and returns all available results that match.   You can use &gt;10 to search for all reportTemplateIds greater than 10. You can use [1,2,3] to search for reportTemplateIds that match either 1, 2 or 3. You can use this parameter multiple times. eg reportTemplateId&#x3D;&gt;5&amp; reportTemplateId&#x3D;&lt;10 would search for all reportTemplateIds between 5 and 10.
     * @param columnName Name of the column in the report.&lt;br&gt;This parameter searches for the columnName field and returns all available results that match. You can use this parameter multiple times and it will do an &#x27;AND&#x27; search. You can use * as a wildcard. You can use brackets and a comma to perform an ‘OR’ search e.g [a,b*] will search for ‘a’ OR a value starting with ‘b’.
     * @param isVisible TRUE if the column is visible in this template.&lt;br&gt;&lt;b&gt;boolean:&lt;/b&gt;
     * @param columnOrder Order of the column for display purposes.&lt;br&gt;&lt;b&gt;integer:&lt;/b&gt; This parameter searches the columnOrder field and returns all available results that match.   You can use &gt;10 to search for all columnOrders greater than 10. You can use [1,2,3] to search for columnOrders that match either 1, 2 or 3. You can use this parameter multiple times. eg columnOrder&#x3D;&gt;5&amp; columnOrder&#x3D;&lt;10 would search for all columnOrders between 5 and 10.
     * @param isGrouped TRUE if the grid should group by this column. Default: FALSE&lt;br&gt;&lt;b&gt;boolean:&lt;/b&gt;
     * @param groupOrder Order in which this column is grouped (if grouped by multiple columns).&lt;br&gt;&lt;b&gt;integer:&lt;/b&gt; This parameter searches the groupOrder field and returns all available results that match.   You can use &gt;10 to search for all groupOrders greater than 10. You can use [1,2,3] to search for groupOrders that match either 1, 2 or 3. You can use this parameter multiple times. eg groupOrder&#x3D;&gt;5&amp; groupOrder&#x3D;&lt;10 would search for all groupOrders between 5 and 10.
     * @param sortDirection Sort direction for this column, e.g., &#x27;ASC&#x27; for ascending, &#x27;DESC&#x27; for descending.&lt;br&gt;This parameter searches for the sortDirection field and returns all available results that match. You can use this parameter multiple times and it will do an &#x27;AND&#x27; search. You can use * as a wildcard. You can use brackets and a comma to perform an ‘OR’ search e.g [a,b*] will search for ‘a’ OR a value starting with ‘b’.
     * @param sortOrder Order in which columns are sorted (if sorted by multiple columns).&lt;br&gt;&lt;b&gt;integer:&lt;/b&gt; This parameter searches the sortOrder field and returns all available results that match.   You can use &gt;10 to search for all sortOrders greater than 10. You can use [1,2,3] to search for sortOrders that match either 1, 2 or 3. You can use this parameter multiple times. eg sortOrder&#x3D;&gt;5&amp; sortOrder&#x3D;&lt;10 would search for all sortOrders between 5 and 10.
     * @param organisationId Allows an api user to filter results by 1 or more organisationIds. To use multiple organisationIds: organisationId&#x3D;[org1,org2]
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public reportTemplateColumnSettingsGet(ridChain?: string, group?: string, groupSummary?: string, totalSummary?: string, searchDistinct?: string, sort?: string, limit?: number, offset?: number, search?: string, templateColumnSettingId?: number, reportTemplateId?: number, columnName?: string, isVisible?: string, columnOrder?: number, isGrouped?: string, groupOrder?: number, sortDirection?: string, sortOrder?: number, organisationId?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<ReportTemplateColumnSettingView>>;
    public reportTemplateColumnSettingsGet(ridChain?: string, group?: string, groupSummary?: string, totalSummary?: string, searchDistinct?: string, sort?: string, limit?: number, offset?: number, search?: string, templateColumnSettingId?: number, reportTemplateId?: number, columnName?: string, isVisible?: string, columnOrder?: number, isGrouped?: string, groupOrder?: number, sortDirection?: string, sortOrder?: number, organisationId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ReportTemplateColumnSettingView>>>;
    public reportTemplateColumnSettingsGet(ridChain?: string, group?: string, groupSummary?: string, totalSummary?: string, searchDistinct?: string, sort?: string, limit?: number, offset?: number, search?: string, templateColumnSettingId?: number, reportTemplateId?: number, columnName?: string, isVisible?: string, columnOrder?: number, isGrouped?: string, groupOrder?: number, sortDirection?: string, sortOrder?: number, organisationId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ReportTemplateColumnSettingView>>>;
    public reportTemplateColumnSettingsGet(ridChain?: string, group?: string, groupSummary?: string, totalSummary?: string, searchDistinct?: string, sort?: string, limit?: number, offset?: number, search?: string, templateColumnSettingId?: number, reportTemplateId?: number, columnName?: string, isVisible?: string, columnOrder?: number, isGrouped?: string, groupOrder?: number, sortDirection?: string, sortOrder?: number, organisationId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {




















        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (group !== undefined && group !== null) {
            queryParameters = queryParameters.set('group', <any>group);
        }
        if (groupSummary !== undefined && groupSummary !== null) {
            queryParameters = queryParameters.set('groupSummary', <any>groupSummary);
        }
        if (totalSummary !== undefined && totalSummary !== null) {
            queryParameters = queryParameters.set('totalSummary', <any>totalSummary);
        }
        if (searchDistinct !== undefined && searchDistinct !== null) {
            queryParameters = queryParameters.set('searchDistinct', <any>searchDistinct);
        }
        if (sort !== undefined && sort !== null) {
            queryParameters = queryParameters.set('sort', <any>sort);
        }
        if (limit !== undefined && limit !== null) {
            queryParameters = queryParameters.set('limit', <any>limit);
        }
        if (offset !== undefined && offset !== null) {
            queryParameters = queryParameters.set('offset', <any>offset);
        }
        if (search !== undefined && search !== null) {
            queryParameters = queryParameters.set('search', <any>search);
        }
        if (templateColumnSettingId !== undefined && templateColumnSettingId !== null) {
            queryParameters = queryParameters.set('templateColumnSettingId', <any>templateColumnSettingId);
        }
        if (reportTemplateId !== undefined && reportTemplateId !== null) {
            queryParameters = queryParameters.set('reportTemplateId', <any>reportTemplateId);
        }
        if (columnName !== undefined && columnName !== null) {
            queryParameters = queryParameters.set('columnName', <any>columnName);
        }
        if (isVisible !== undefined && isVisible !== null) {
            queryParameters = queryParameters.set('isVisible', <any>isVisible);
        }
        if (columnOrder !== undefined && columnOrder !== null) {
            queryParameters = queryParameters.set('columnOrder', <any>columnOrder);
        }
        if (isGrouped !== undefined && isGrouped !== null) {
            queryParameters = queryParameters.set('isGrouped', <any>isGrouped);
        }
        if (groupOrder !== undefined && groupOrder !== null) {
            queryParameters = queryParameters.set('groupOrder', <any>groupOrder);
        }
        if (sortDirection !== undefined && sortDirection !== null) {
            queryParameters = queryParameters.set('sortDirection', <any>sortDirection);
        }
        if (sortOrder !== undefined && sortOrder !== null) {
            queryParameters = queryParameters.set('sortOrder', <any>sortOrder);
        }
        if (organisationId !== undefined && organisationId !== null) {
            queryParameters = queryParameters.set('organisationId', <any>organisationId);
        }

        let headers = this.defaultHeaders;
        if (ridChain !== undefined && ridChain !== null) {
            headers = headers.set('rid_chain', String(ridChain));
        }

        // authentication (BearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ReportTemplateColumnSettingView>>('get',`${this.basePath}/ReportTemplateColumnSettings/`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Delete a ReportTemplateColumnSetting object&lt;br&gt;&lt;br&gt;Defines the column settings in the grid view for each template.&lt;br&gt;&lt;br&gt;You will need to have the following data accesses assigned to your user to use this route: sc_delete_reporttemplatecolumnsettings
     * @param id Used to identify a specific record by its unique ID
     * @param ridChain The rid_chain is used to track the current users session. It should be a unique value that identifies a users particular session in a particular device. When events are received through H&amp;L websocket events, the current user&#x27;s session can be identified with this value. As such this value can help you determine which device a user was on when they made a request on this API.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public reportTemplateColumnSettingsIdDelete(id: number, ridChain?: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public reportTemplateColumnSettingsIdDelete(id: number, ridChain?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public reportTemplateColumnSettingsIdDelete(id: number, ridChain?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public reportTemplateColumnSettingsIdDelete(id: number, ridChain?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling reportTemplateColumnSettingsIdDelete.');
        }


        let headers = this.defaultHeaders;
        if (ridChain !== undefined && ridChain !== null) {
            headers = headers.set('rid_chain', String(ridChain));
        }

        // authentication (BearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('delete',`${this.basePath}/ReportTemplateColumnSettings/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Gets a ReportTemplateColumnSetting object&lt;br&gt;&lt;br&gt;Defines the column settings in the grid view for each template.&lt;br&gt;&lt;br&gt;You will need to have the following data accesses assigned to your user to use this route: sc_get_reporttemplatecolumnsettings
     * @param id Used to identify a specific record by its unique ID
     * @param ridChain The rid_chain is used to track the current users session. It should be a unique value that identifies a users particular session in a particular device. When events are received through H&amp;L websocket events, the current user&#x27;s session can be identified with this value. As such this value can help you determine which device a user was on when they made a request on this API.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public reportTemplateColumnSettingsIdGet(id: number, ridChain?: string, observe?: 'body', reportProgress?: boolean): Observable<ReportTemplateColumnSettingView>;
    public reportTemplateColumnSettingsIdGet(id: number, ridChain?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ReportTemplateColumnSettingView>>;
    public reportTemplateColumnSettingsIdGet(id: number, ridChain?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ReportTemplateColumnSettingView>>;
    public reportTemplateColumnSettingsIdGet(id: number, ridChain?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling reportTemplateColumnSettingsIdGet.');
        }


        let headers = this.defaultHeaders;
        if (ridChain !== undefined && ridChain !== null) {
            headers = headers.set('rid_chain', String(ridChain));
        }

        // authentication (BearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ReportTemplateColumnSettingView>('get',`${this.basePath}/ReportTemplateColumnSettings/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Update a ReportTemplateColumnSetting object&lt;br&gt;&lt;br&gt;Defines the column settings in the grid view for each template.&lt;br&gt;&lt;br&gt;You will need to have the following data accesses assigned to your user to use this route: sc_update_reporttemplatecolumnsettings
     * @param id Used to identify a specific record by its unique ID
     * @param body 
     * @param ridChain The rid_chain is used to track the current users session. It should be a unique value that identifies a users particular session in a particular device. When events are received through H&amp;L websocket events, the current user&#x27;s session can be identified with this value. As such this value can help you determine which device a user was on when they made a request on this API.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public reportTemplateColumnSettingsIdPut(id: number, body?: ReportTemplateColumnSettingUpdate, ridChain?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<ReportTemplateColumnSettingView>>;
    public reportTemplateColumnSettingsIdPut(id: number, body?: ReportTemplateColumnSettingUpdate, ridChain?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ReportTemplateColumnSettingView>>>;
    public reportTemplateColumnSettingsIdPut(id: number, body?: ReportTemplateColumnSettingUpdate, ridChain?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ReportTemplateColumnSettingView>>>;
    public reportTemplateColumnSettingsIdPut(id: number, body?: ReportTemplateColumnSettingUpdate, ridChain?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling reportTemplateColumnSettingsIdPut.');
        }



        let headers = this.defaultHeaders;
        if (ridChain !== undefined && ridChain !== null) {
            headers = headers.set('rid_chain', String(ridChain));
        }

        // authentication (BearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<Array<ReportTemplateColumnSettingView>>('put',`${this.basePath}/ReportTemplateColumnSettings/${encodeURIComponent(String(id))}`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Creates a new ReportTemplateColumnSetting&lt;br&gt;&lt;br&gt;Defines the column settings in the grid view for each template.&lt;br&gt;&lt;br&gt;You will need to have the following data accesses assigned to your user to use this route: sc_insert_reporttemplatecolumnsettings
     * @param body 
     * @param ridChain The rid_chain is used to track the current users session. It should be a unique value that identifies a users particular session in a particular device. When events are received through H&amp;L websocket events, the current user&#x27;s session can be identified with this value. As such this value can help you determine which device a user was on when they made a request on this API.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public reportTemplateColumnSettingsPost(body?: ReportTemplateColumnSettingInsert, ridChain?: string, observe?: 'body', reportProgress?: boolean): Observable<ReportTemplateColumnSettingView>;
    public reportTemplateColumnSettingsPost(body?: ReportTemplateColumnSettingInsert, ridChain?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ReportTemplateColumnSettingView>>;
    public reportTemplateColumnSettingsPost(body?: ReportTemplateColumnSettingInsert, ridChain?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ReportTemplateColumnSettingView>>;
    public reportTemplateColumnSettingsPost(body?: ReportTemplateColumnSettingInsert, ridChain?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let headers = this.defaultHeaders;
        if (ridChain !== undefined && ridChain !== null) {
            headers = headers.set('rid_chain', String(ridChain));
        }

        // authentication (BearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<ReportTemplateColumnSettingView>('post',`${this.basePath}/ReportTemplateColumnSettings/`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
